import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import Toggle from 'react-toggle'
import moment from 'moment'
import { toastr } from 'react-redux-toastr';
import _ from 'lodash'
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick'
import { FaChevronDown, FaChevronUp, FaChevronLeft, FaChevronRight } from 'react-icons/fa'

import momenttz from '../../helpers/momenttz'
import SnapshotChannelNode from './SnapshotChannelNode'
import ModalRequestContextVideo from './ModalRequestContextVideo'
import CustomButton from '../../CustomButton'
import EventFeedback from '../../EventFeedback'
import Controls from '../../Controls'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"

import { isCustomUserPermissions } from '../../helpers/helperUsers'
import { getEventSnapshots, requestEventVideo } from '../../../action/AlertActions'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './EventViewSnapshotModal.sass'

const SamplePrevArrow = (props) => {
	const { className, onClick } = props
	return (
		<div
			className={className}
			onClick={onClick}
		>
			{/* <span className="glyphicon glyphicon-chevron-left" /> */}
			<FaChevronLeft />
		</div>
	)
}

const SampleNextArrow = (props) => {
	const { className, onClick } = props
	return (
		<div
			className={className}
			onClick={onClick}
		>
			{/* <span className="glyphicon glyphicon-chevron-right" /> */}
			<FaChevronRight />
		</div>
	)
}

const EventViewSnapshotModal = (props) => {
	const { event, getFleetEvents, onHide, user, company, tripSnapshots, toggleLoader } = props;
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'homePage.vehicleSidebar.eventViewSnapshotModal' });
	const { roles, permissions } = user;
	const userRole = user.roles[0];
	const userPermissions = user.permissions;
	const canEventFeedbackView = ['system_admin', 'customer_service', 'sales_demo', 'partner', 'fleet_manager'].includes(userRole)
		|| (['custom_user', 'custom_partner'].includes(userRole) && isCustomUserPermissions(userRole, userPermissions, 'event_feedback_add'))
		|| (['custom_user', 'custom_partner'].includes(userRole) && isCustomUserPermissions(userRole, userPermissions, 'event_feedback_edit'))

	const [channel, setChannel] = useState(1)
	const [snapshots, setSnapshots] = useState([]) // stores snapshots from the snapshots_urls array response of the /events/[EVENT ID]/snapshots API
	const [snapshotsMultiple, setSnapshotsMultiple] = useState(null) // FWSD-7611, stores multiple snapshots if event_type=SNAPSHOTS_CLIP and the /events/[EVENT ID]/snapshots APPI returns snapshots object
	const [currentSnapshot, setCurrentSnapshot] = useState(null) // FWSD-7611, current selected snapshot displayed in img
	const [channels, setChannels] = useState([])
	const [showRequestContextVideo, setShowRequestContextVideo] = useState(false)
	const [showCalibrationBox, setShowCalibrationBox] = useState(false)
	const [showAdasCalibrationBox, setShowAdasCalibrationBox] = useState(false)
	const [showZoomControls, setShowZoomControls] = useState(false)
	// const canEventFeedbackView = ['system_admin', 'customer_service', 'sales_demo', 'partner'].includes(userRole)
	// 	|| isCustomUserPermissions(userRole, userPermissions, 'event_feedback_add')
	// 	|| isCustomUserPermissions(userRole, userPermissions, 'event_feedback_edit')

	const sliderSettings = {
		dots: false,
		infinite: false,
		speed: 400,
		// slidesToShow,
		slidesToShow: 4,
		slidesToScroll: 1,
		nextArrow: <SampleNextArrow />,
		prevArrow: <SamplePrevArrow />,
		// afterChange: (q,w,e) => console.log('afterChange: ', q,w,e),
		// onInit: (q,w,e) => console.log('onInit: ', q,w,e),
		// onReInit: (q,w,e) => console.log('onReInit: ', q,w,e),
		// onSwipe: (q,w,e) => console.log('onSwipe: ', q,w,e),
	}

	useEffect(() => {
		let channels = [0, 0, 0, 0]
		let channel = 0

		const items = event ? event : tripSnapshots

		if (items.snapshot_4) {
			channels[3] = true;
			channel = 4;
		}
		if (items.snapshot_3) {
			channels[2] = true;
			channel = 3;
		}
		if (items.snapshot_2) {
			channels[1] = true;
			channel = 2;
		}
		if (items.snapshot_1) {
			channels[0] = true;
			channel = 1;
		}

		if (channel === 0) {
			channels = [];
		}

		if (event && items.snapshot_2 && ['External Driver', 'Driver', 'Drowsiness', 'Distraction', 'Phone Use', 'Custom Alert Distraction', 'Custom Alert Drowsiness', 'Custom Alert Phone Use', 'CameraBlock', 'Drowsiness/Head Down', 'Phone Use/Hand to Head', 'Yawning', 'Seatbelt', 'Smoking', 'Potential Ch2 Obstruction'].includes(items.type)) {
			channel = 2;
		}

		setChannel(channel);
		setChannels(channels);

		if (event) {
			viewSnapshot();
		} else if (tripSnapshots) {
			const snapshots = []
			if (tripSnapshots.snapshot_1) {
				snapshots.push(tripSnapshots.snapshot_1)
			}
			if (tripSnapshots.snapshot_2) {
				snapshots.push(tripSnapshots.snapshot_2)
			}
			if (tripSnapshots.snapshot_3) {
				snapshots.push(tripSnapshots.snapshot_3)
			}
			if (tripSnapshots.snapshot_4) {
				snapshots.push(tripSnapshots.snapshot_4)
			}
			setSnapshots(snapshots);

			const snapshot = document.getElementById('event-snapshot')
			snapshot.src = snapshots[0]

			// const snapshot = document.getElementById('event-snapshot');
			// if (event.snapshot_2 && (['External Driver', 'Driver', 'Drowsiness', 'Distraction', 'Phone Use', 'Custom Alert Distraction', 'Custom Alert Drowsiness', 'Custom Alert Phone Use'].indexOf(event.type) > -1)) {
			// 	snapshot.src = event.snapshot_2;
			// }
			// else {
			// 	snapshot.src = snapshots[0]
			// }
		}
	}, [])

	useEffect(() => {
		if (showZoomControls) {
			$(document).mouseup((e) => { if (($('.vjs-zoom__container')[0] && !$('.vjs-zoom__container')[0].contains(e.target)) && !$('.btn-zoom')[0].contains(e.target)) { setShowZoomControls(false) } });
		}
	}, [showZoomControls])

	const viewSnapshot = () => {
		toggleLoader(true);

		const data = {
			user_role: user.roles[0],
			event_id: event.id,
			company_name: company.name,
			partner_name: company.partner,
		}
		getEventSnapshots(data)
			.then((res, err) => {
				toggleLoader(false);

				if (res.data.response.error) {
					toastr.error(i18n.t('errorMessage.errDescription'));
				} else {
					const { snapshots_urls, snapshots } = res.data.response
					setSnapshots(snapshots_urls)
					setSnapshotsMultiple(snapshots)

					// if event_type='SNAPSHOTS_CLIP'
					if (snapshots) {
						// takes the first image and assigns to currentSnapshot
						const firstAvailableChannel = +Object.keys(snapshots)[0]
						setChannel(firstAvailableChannel)
						setCurrentSnapshot(snapshots[firstAvailableChannel][0].image_src)
					}
					else {
						const snapshot = document.getElementById('event-snapshot');
						if (event.snapshot_2 && ['External Driver', 'Driver', 'Drowsiness', 'Distraction', 'Phone Use', 'Custom Alert Distraction', 'Custom Alert Drowsiness', 'Custom Alert Phone Use', 'CameraBlock', 'Drowsiness/Head Down', 'Phone Use/Hand to Head', 'Yawning', 'Seatbelt', 'Smoking', 'Potential Ch2 Obstruction'].includes(event.type)) {
							snapshot.src = event.snapshot_2;
						}
						else {
							snapshot.src = res.data.response.snapshots_urls[0];
						}
					}
				}
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!getEventSnapshots error: ', error.response, error);
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response?.data?.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const changeChannel = (argChannel) => {
		if (argChannel === channel) return;

		setChannel(argChannel);
		setShowZoomControls(false);

		const snapshot = document.getElementById('event-snapshot')

		const re = RegExp('\/' + argChannel + '.jpeg?', 'i')
		const re1 = RegExp('\_' + argChannel + '.jpeg?', 'i')
		snapshots.forEach((item) => {
			if (item.search(re) > -1 || item.search(re1) > -1) {
				snapshot.src = item
			}
		})

		// snapshot.src = snapshots[channel-1]
	}

	const openRequestContextVideo = () => {
		setShowRequestContextVideo(true);
	}

	const closeRequestContextVideo = () => {
		setShowRequestContextVideo(false);
	}

	// FWSD-4740, create custom clip for the trip snapshots from the Homepage
	const createCustomClip = (e) => {
		e.preventDefault()

		const params = {
			device_id: tripSnapshots.device_id,
			start_ts: moment(tripSnapshots.timestamp).add(-5, 'seconds').format('YYYYMMDDHHmmss'),
			end_ts: moment(tripSnapshots.timestamp).add(5, 'seconds').format('YYYYMMDDHHmmss'),
		}
		toggleLoader(true);
		requestEventVideo(params)
			.then((res, err) => {
				toggleLoader(false);
				console.log('requestCustomVideo res, err: ', res, err);

				toastr.success('', i18n.t('toastMessage.toastrSuccessCVR'));
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('requestCustomVideo error: ', error.response, error);
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const channelsList = () => {
		const options = []
		for (let i = 0; i < 4; i++) {
			if (channels[i]) {
				const index = i + 1
				options[i] = <SnapshotChannelNode
					key={index}
					index={index}
					activechannel={channel}
					changeChannel={changeChannel}
				/>
			}
		}

		return (
			<>
				<ul className="list-inline chanels-list" >
					{options}
				</ul>

				{channel === 1 &&
					<label>
						<span className="toggle-left-title">{t('showADASBox')}</span>
						<Toggle
							icons={false}
							checked={showAdasCalibrationBox || false}
							onChange={() => setShowAdasCalibrationBox(!showAdasCalibrationBox)}
						/>
					</label>
				}
				{channel === 2 &&
					<label>
						<span className="toggle-left-title">{t('showDMSBox')}</span>
						<Toggle
							icons={false}
							checked={showCalibrationBox || false}
							onChange={() => setShowCalibrationBox(!showCalibrationBox)}
						/>
					</label>
				}

				<div className={channel === 2 ? "flexRow" : ""}>
					<CustomButton
						variant="link"
						style={{ textDecorationLine: 'none' }}
						prefix="btn-zoom"
						onClick={() => setShowZoomControls(!showZoomControls)}
					>
						{t('btnZoom')}
					</CustomButton>

					{!(['custom_user', 'custom_partner'].includes(roles[0]) && _.find(permissions, { 'perm_category_id': 2, 'a_edit': false })) && (
						<>
							{event
								? (
									<CustomButton
										variant="primary-outline"
										title={t('btnRequestAdditionalVideo')}
										prefix="btn-request-video"
										style={{ margin: 0 }}
										disabled={event?.uploading_status === 'EVENT_REPORTED'}
										onClick={openRequestContextVideo}
									>
										{t('btnRequestAdditionalVideo')}
									</CustomButton>
								)
								: (
									<CustomButton
										variant="primary-outline"
										title={t('btnRequestVideo')}
										style={{ margin: 0 }}
										onClick={createCustomClip}
									>
										{t('btnRequestVideo')}
									</CustomButton>
								)
							}
						</>
					)}
				</div>
			</>
		)
	}

	const channelsListMultiple = () => {
		const availableChannels = Object.keys(snapshotsMultiple).map(Number)

		const onChannelClick = (channelNumber) => {
			setCurrentSnapshot(snapshotsMultiple[channelNumber][0].image_src)
			setChannel(channelNumber)
		}

		return (
			<div className="available-channels">
				{
					availableChannels.map((key) => (
						<CustomButton
							key={key}
							variant={`primary${key !== channel ? '-outline' : ''}`}
							size="sm"
							onClick={() => onChannelClick(key)}
						>
							Channel {key}
						</CustomButton>
					))
				}
			</div>
		)
	}

	const onSnapshotClick = (snapshotIndex) => {
		const snapshotURL = snapshotsMultiple[channel][snapshotIndex]?.image_src || ''
		setCurrentSnapshot(snapshotURL)
	}

	const snapshotSlider = () => (
		<div className="images-wrapper">
			<Slider
				{...sliderSettings}
			>
				{
					snapshotsMultiple[channel].map((item, index) => {
						return (
							<div
								style={{ textAlign: 'center' }}
								key={index}
								className={`image-block${item.image_src === currentSnapshot ? ' active' : ''}`}
							>
								<img
									style={{ width: '200px', borderRadius: '4px', }}
									src={item.image_src}
									alt=""
									// onMouseEnter={() => setHoverImageIndex(index)}
									// onMouseLeave={() => setHoverImageIndex(null)}
									onClick={() => onSnapshotClick(index)}
								/>
								<div className="time-wrapper">
									{momenttz(`${item.timestamp}+00`).format('h:mm:ss a')}
								</div>
							</div>
						)
					})
				}
			</Slider>
		</div>
	)

	const element = document.getElementById('event-snapshot');
	const style = { bottom: '1rem', right: '1rem' };
	const isSnapshotsMultiple = snapshotsMultiple

	return (
		<Modal
			size={`${isSnapshotsMultiple ? 'super-' : ''}lg`}
			show
			onHide={onHide}
			// onEnter={onEnterModal}
			dialogClassName="event-snapshots-modal"
			aria-labelledby="contained-modal-title-lg "
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-lg">
					<span style={{ marginRight: '15px' }}>{t('titleSnapshots')}</span>
					{canEventFeedbackView &&
						<EventFeedback
							event={event}
							getFleetEvents={getFleetEvents}
						/>
					}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{isSnapshotsMultiple
					? (
						<div>
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
								{currentSnapshot
									? <img width="100%" alt="" style={{ maxWidth: '900px' }} src={currentSnapshot} />
									: <div>{t('textNoSnapshotAvailable')}</div>
								}
								{channelsListMultiple()}
							</div>
							{snapshotSlider()}
						</div>
					)
					: (
						<div>
							<TransformWrapper>
								<Controls
									element={element}
									style={style}
									changeChannel={channel}
									showZoomControls={showZoomControls}
								/>
								<TransformComponent>
									<img width="100%" id="event-snapshot" alt="" />
								</TransformComponent>
							</TransformWrapper>
							{channel === 1 && showAdasCalibrationBox && (
								<div className="calibration-box-adas">
									<div className="mibble-calibration-bar" />
									<div className="middle-calibration-line" />
									<div className="bottom-calibration-bar" />
								</div>
							)}
							{channel === 2 && showCalibrationBox && <div className="calibration-box" />}
						</div>
					)
				}
			</Modal.Body>
			{!isSnapshotsMultiple &&
				<Modal.Footer className='flex-center' style={{ padding: 0, margin: "0 16px 16px", display: "flex", justifyContent: "space-between" }}>
					{channelsList()}
				</Modal.Footer>
			}

			{showRequestContextVideo
				&& (
					<ModalRequestContextVideo
						event={event}
						onHide={closeRequestContextVideo}
					/>
				)}
		</Modal>
	);
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company
	}),
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	}),
)(EventViewSnapshotModal);
